export enum CycleVerificationActions {
    NOACTION = 0,
    PENDING = 1,
    APPROVED = 2,
    DECLINED = 3,
    FORGIVEN=4,
    REOPENED=5,
    DUE_DATE_CHANGED=6,
    SUBMITTED=10,
    COMPLETED=11,   // For Verification History
    NUDGED=100,
    MESSAGE=101,
    CREATED=200,
    FINALIZED=999
}